/**
 * LoadingSpinner Component
 * Provides visual feedback during authentication and loading states
 */

import React from 'react';
import { Spinner } from './ui/spinner';
import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  text,
  className
}) => {
  const sizeClasses = {
    sm: 'size-4',
    md: 'size-6',
    lg: 'size-8'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  return (
    <div 
      className={cn('flex items-center justify-center gap-2', className)}
      role="status"
      aria-live="polite"
    >
      <Spinner 
        className={sizeClasses[size]} 
        aria-hidden="true"
      />
      {text && (
        <span 
          className={cn('text-muted-foreground', textSizeClasses[size])}
          aria-label={`Loading: ${text}`}
        >
          {text}
        </span>
      )}
      {!text && (
        <span className="sr-only">Loading...</span>
      )}
    </div>
  );
};